<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane :label="$t('tab.route_version_view')" name="0">
        <RouteVersionSearch @goRouteDiff="goRouteDiff"></RouteVersionSearch>
      </el-tab-pane>
      <el-tab-pane :label="$t('tab.route_version_diff')" name="1">
        <RouteVersionDiff ref="RouteDiff"></RouteVersionDiff>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import RouteVersionSearch from './RouteVersionSearch.vue';
import RouteVersionDiff from './RouteVersionDiff.vue';

export default {
  components: {
    RouteVersionSearch,
    RouteVersionDiff
  },
  data() {
    return {
      tab_index: "0"
    }
  },
  methods: {
    goRouteDiff(t) {
      this.tab_index = "1";
      this.$refs.RouteDiff.RouteVersion1 = t.RouteVersion1;
      this.$refs.RouteDiff.RouteVersion2 = t.RouteVersion2;
      this.$refs.RouteDiff.getDiff(function () { })
    }
  }
}
</script>
